import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BannerHeaderInlineStyles = /*#__PURE__*/function () {
  function BannerHeaderInlineStyles() {
    _classCallCheck(this, BannerHeaderInlineStyles);
  }

  _createClass(BannerHeaderInlineStyles, null, [{
    key: "headerContainer",
    value: function headerContainer(_ref) {
      var _ref$layout = _ref.layout,
          type = _ref$layout.type,
          dialogBorderRadius = _ref$layout.dialogBorderRadius,
          _ref$design = _ref.design,
          borderWidth = _ref$design.borderWidth,
          borderColor = _ref$design.borderColor,
          restDesign = _objectWithoutProperties(_ref$design, ["borderWidth", "borderColor"]),
          _ref$headerDesign = _ref.headerDesign,
          inheritBg = _ref$headerDesign.inheritBg,
          bg = _ref$headerDesign.bg,
          padding = _ref$headerDesign.padding,
          antiAdBlocker = _ref.customCss.antiAdBlocker;

      var style = {
        padding: padding.map(function (p) {
          return "".concat(p, "px");
        }).join(" "),
        background: inheritBg ? restDesign.bg : bg,
        borderRadius: type === "dialog" ? "".concat(dialogBorderRadius, "px ").concat(dialogBorderRadius, "px 0 0") : undefined,
        position: "sticky",
        zIndex: 9,
        top: 0
      };

      if (type === "dialog" && borderWidth > 0) {
        style.borderTop = "".concat(borderWidth, "px solid ").concat(borderColor);
        style.borderLeft = style.borderTop;
        style.borderRight = style.borderTop;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-header-container",
        style: style
      };
    }
  }, {
    key: "header",
    value: function header(_ref2) {
      var _ref2$layout = _ref2.layout,
          type = _ref2$layout.type,
          bannerMaxWidth = _ref2$layout.bannerMaxWidth,
          textAlign = _ref2.design.textAlign,
          _ref2$headerDesign = _ref2.headerDesign,
          inheritTextAlign = _ref2$headerDesign.inheritTextAlign,
          logo = _ref2$headerDesign.logo,
          logoPosition = _ref2$headerDesign.logoPosition,
          restHeaderDesign = _objectWithoutProperties(_ref2$headerDesign, ["inheritTextAlign", "logo", "logoPosition"]),
          headline = _ref2.texts.headline,
          individualLayout = _ref2.individualLayout,
          antiAdBlocker = _ref2.customCss.antiAdBlocker,
          individualPrivacyOpen = _ref2.individualPrivacyOpen;

      var useTextAlign = inheritTextAlign ? textAlign : restHeaderDesign.textAlign;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-header",
        style: {
          transition: "width 500ms, max-width 500ms",
          maxWidth: type === "banner" ? +(individualPrivacyOpen && !individualLayout.inheritBannerMaxWidth ? individualLayout.bannerMaxWidth : bannerMaxWidth) : undefined,
          margin: "auto",
          display: "flex",
          justifyContent: useTextAlign === "center" ? "center" : useTextAlign === "right" ? "flex-end" : undefined,
          alignItems: "center",
          flexDirection: logo && headline ? logoPosition === "left" ? "row" : logoPosition === "right" ? "row-reverse" : "column" : undefined
        }
      };
    }
  }, {
    key: "logo",
    value: function logo(_ref3, isRetina) {
      var _ref3$headerDesign = _ref3.headerDesign,
          logoMaxHeight = _ref3$headerDesign.logoMaxHeight,
          logoMargin = _ref3$headerDesign.logoMargin,
          logoFitDim = _ref3$headerDesign.logoFitDim,
          logoRetinaFitDim = _ref3$headerDesign.logoRetinaFitDim,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      var useFitDim = isRetina ? logoRetinaFitDim : logoFitDim;
      var dimStyle = useFitDim ? {
        width: useFitDim[0],
        height: useFitDim[1]
      } : {
        width: "auto",
        height: +logoMaxHeight
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-logo",
        style: _objectSpread(_objectSpread({}, dimStyle), {}, {
          margin: logoMargin.map(function (m) {
            return "".concat(m, "px");
          }).join(" ") //[logoPosition === "left" ? "marginRight" : "marginLeft"]: logoPosition === "above" ? undefined : 15,
          //marginBottom: logoPosition === "above" ? 5 : undefined

        })
      };
    }
  }, {
    key: "headline",
    value: function headline(_ref4) {
      var _ref4$headerDesign = _ref4.headerDesign,
          fontSize = _ref4$headerDesign.fontSize,
          fontColor = _ref4$headerDesign.fontColor,
          fontInheritFamily = _ref4$headerDesign.fontInheritFamily,
          fontFamily = _ref4$headerDesign.fontFamily,
          fontWeight = _ref4$headerDesign.fontWeight,
          antiAdBlocker = _ref4.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-headline",
        style: {
          color: fontColor,
          fontSize: +fontSize,
          fontFamily: fontInheritFamily ? undefined : fontFamily,
          fontWeight: fontWeight
        }
      };
    }
  }, {
    key: "headerSeparator",
    value: function headerSeparator(_ref5) {
      var type = _ref5.layout.type,
          design = _ref5.design,
          _ref5$headerDesign = _ref5.headerDesign,
          borderWidth = _ref5$headerDesign.borderWidth,
          borderColor = _ref5$headerDesign.borderColor,
          antiAdBlocker = _ref5.customCss.antiAdBlocker,
          headerContainer = _ref5.renderedHeights.headerContainer;
      var style = {
        height: +borderWidth,
        background: borderColor,
        position: "sticky",
        top: +headerContainer,
        zIndex: 9
      };

      if (type === "dialog" && design.borderWidth > 0) {
        style.borderLeft = "".concat(design.borderWidth, "px solid ").concat(design.borderColor);
        style.borderRight = style.borderLeft;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-header-separator",
        style: style
      };
    }
  }]);

  return BannerHeaderInlineStyles;
}();

export { BannerHeaderInlineStyles };